import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FieldError } from '../../../elements/field-error/field-error';
import { Button } from '../../../elements/button';
import { DatePicker } from '../../../elements/date-picker';





export const ConductoresForm = ({
    onAction
}: {
    onAction?: () => void;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const navigate = useNavigate();
    const [data, setData] = useState<any | null>(null);
    const [showMessage, setShowMessage] = useState(false);

    // construccion del objeto yup de validacion del cuestionario
    const obligado = {
        email: Yup.string().email('email no valida').required('obligatorio')
    };

    const obligado2 = {
        email: Yup.string().email('email no valida').required('obligatorio'),
        first_name: Yup.string().required('obligatorio'),
        last_name: Yup.string().required('obligatorio'),
        password: Yup.string()
            .required('obligatorio')
            .min(8, 'Min 8 characters')
    };

    const validacion = showMessage
        ? Yup.object().shape(obligado2)
        : Yup.object().shape(obligado);

    const initialValues: any = {
        email: '',
    };



    const beforeSubmit = (values: any) => {
        const after = { ...values };

        return after;
    };

    const onSubmit = async (values: any) => {
        const enviaremos = beforeSubmit(values);

        /*     let formdata = new FormData();
    
            if (enviaremos.photo) {
                if (enviaremos.photo.photo) {
                    formdata.append(
                        'photo',
                        enviaremos.photo.photo[0],
                        enviaremos.photo.photo[0].name
                    );
                }
            } */


        /*       for (let key in enviaremos) {
                  if (key !== 'photo') {
                      formdata.append(key, enviaremos[key] ? enviaremos[key] : "");
                  }
              }
       */

        // create

        api('/fleet/drivers/', 'POST', enviaremos);


    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('/drivers/')) {
                if (state.method === 'POST') {
                    toast.success(`${t('common.label.success-saved')}`);
                    setShowMessage(false);
                    navigate(-1);
                }
            }
        }

        if (state.error) {
            if (state.error.email && state.error.email == 'Driver already exists for this user') {
                toast.error(`${t('common.error.already-driver-exist')}`);
            } else if (state.error.error && state.error.error == 'El email proporcionado no existe. Para crear un nuevo usuario, debe proporcionar first_name, last_name y password.') {
                //toast.error(`${t('common.error.no-email-exist')}`);
                setShowMessage(true);
            } else {
                toast.error('Server Error');
            }

        }
    }, [state]);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validacion}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className='w-full py-4 flex'>

                        <div className='w-[300px]'>
                            <Input
                                label={t('usuario.form.email')}
                                type="email"
                                placeholder={t('usuario.form.email')}
                                name="email"
                                value={values.email}
                                onChange={(value) =>
                                    setFieldValue('email', value.email)
                                }
                            />
                            <FieldError touched={touched} errors={errors} field={"email"} />
                        </div>

                        {showMessage ? <>




                            <div className='w-1/2 pl-12'>
                                {/* <div>
                                <span className="block text-sm font-semibold leading-6 text-gray-700">{t('common.form-label.foto')}</span>
                                {data?.photo_display_url ? <div className=''>
                                    <img className='w-[150px] pb-4' src={data?.photo_display_url} />
                                </div> : id ? <div className='w-[150px] h-[168px] bg-gray-300'> </div> : ''
                                }
                            </div>
                            <div className='w-full'>
                                {id ? <span className="block text-sm font-semibold leading-6 text-gray-700">{data?.photo_display_url ? t('common.label.cambiar-foto') : t('common.label.add-foto')}</span> : ''}
                                <FileInputElement
                                    name="photo"
                                    accept={'image/png, image/jpeg'}
                                    onChange={(value) => {
                                        // Extraemos directamente el FileList del objeto que retorna el FileInputElement
                                        setFieldValue('photo', value);
                                    }}
                                />
                            </div> */}
                            </div>
                        </> : ''}


                    </div>
                    {showMessage ? <div className='text-[14px] text-red-500'>{t('common.error.driver-create')}</div> : ''}
                    {showMessage ? <div className='flex pt-8'>

                        <div className=''>

                            <Input
                                label={t('usuario.form.first_name')}
                                type="text"
                                placeholder={t('usuario.form.first_name')}
                                name="first_name"
                                value={values.first_name}
                                onChange={(value) =>
                                    setFieldValue('first_name', value.first_name)
                                }
                            />
                            <FieldError touched={touched} errors={errors} field={"first_name"} />

                        </div>
                        <div className='pl-8'>

                            <Input
                                label={t('usuario.form.last_name')}
                                type="text"
                                placeholder={t('usuario.form.last_name')}
                                name="last_name"
                                value={values.last_name}
                                onChange={(value) =>
                                    setFieldValue('last_name', value.last_name)
                                }
                            />
                            <FieldError touched={touched} errors={errors} field={"last_name"} />
                        </div>
                        <div className='pl-8'>
                            <Input
                                label={t('usuario.form.password')}
                                type="text"
                                placeholder={t('usuario.form.password')}
                                name="password"
                                value={values.password}
                                onChange={(value) =>
                                    setFieldValue('password', value.password)
                                }
                            />
                            <FieldError touched={touched} errors={errors} field={"password"} />
                        </div>
                    </div> : ''}
                    {showMessage ? <div className='flex pt-4'>
                        <div className=''>
                            <Input
                                label={t('common.form-label.tipo-carnet')}
                                type="text"
                                placeholder={t('common.form-label.tipo-carnet')}
                                name="license_types"
                                value={values.license_types}
                                onChange={(value) =>
                                    setFieldValue('license_types', value.license_types)
                                }
                            />
                        </div>
                        <div className='pl-8'>
                            <DatePicker
                                name="license_date"
                                type="date"
                                label={t(
                                    'common.label.fecha-caducidad-carnet'
                                )}
                                value={
                                    (data
                                        ? dayjs(
                                            data.license_date
                                        ).format(
                                            'YYYY-MM-DD'
                                        )
                                        : '') ||
                                    values.license_date
                                }
                                onChange={(value) => {
                                    setFieldValue(
                                        'license_date',
                                        value.license_date
                                            ? dayjs(
                                                value.license_date
                                            ).format(
                                                'YYYY-MM-DD'
                                            )
                                            : null
                                    );
                                }}
                            />

                        </div>
                    </div> : ''}



                    <Button
                        label={t('common.button.save')}
                        onClick={handleSubmit}
                    />
                </form>
            )}
        </Formik>
    );
};